import React, { Fragment, useState } from 'react';
import i18n from '../../../i18n';
import CharsRow from './CharsRow';
import './CharsTable.css';
import './GrowthCharsMetricTable.css';
import CompText from '../Compliance/CompText';
import { setAllGrowthChars } from '../../../actions';
import Select from 'react-select';
import GrowthCharsMetricsTable from './GrowthCharsMetricsTable';
import GrowthCharsMetricsRow from './GrowthCharsMetricsRow';
import { useSelector, useDispatch } from 'react-redux';

const customStyles = {
  control: (base) => ({
    ...base,
    borderRadius: 0,
    border: '1px solid #050139', // default border color
    boxShadow: 'none',
  }),
  option: (provided) => ({
    ...provided,
    color: '#5b6770',
    fontSize: 14,
    borderRadius: 0,
    backgroundColor: 'white',
    '&:hover': {
      backgroundColor: '#050139',
      color: 'white',
    },
    overflowY: 'hidden',
  }),
  menu: (base) => ({
    ...base,
    borderRadius: 0,
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 100ms';
    return { ...provided, opacity, transition };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: '#050139',
  }),
};

const fixedIncomeRows = [
  { displayName: 'Yield To Maturity', name: 'YTM', type: '%' },
  { displayName: 'Yield to Worst', name: 'YTW', type: '%' },
  { displayName: 'Effective Duration', name: 'effDur', type: '.' },
  { displayName: 'Spread Duration', name: 'SDur', type: '.' },
  { displayName: 'Duration Times Spread', name: 'DTS', type: '.' },
  { displayName: 'Average Years To Maturity', name: 'Yrs2Mat', type: '.' },
  { displayName: 'Weighted Average Life', name: 'WAL', type: '.' },
  { displayName: 'Convexity', name: 'Convexity', type: '.' },
  { displayName: 'Weighted Average Coupon', name: 'Coupon', type: '%' },
  { displayName: 'Average Price', name: 'AvePrice', type: '.' },
  { displayName: 'Option Adjusted Spread', name: 'OAS', type: '.' },
];

const dividendBuybackRows = [
  { displayName: 'Dividend Yield', name: 'DividendYield', type: '%' },
  { displayName: 'Net Buy Back Yield', name: 'NetBuyBackYield', type: '%' },
  {
    displayName: 'Share Reduction Yield',
    name: 'Share_Reduction_Yield',
    type: '%',
  },
  { displayName: 'Shareholder Yield', name: 'ShareholderYield', type: '%' },
];

const valuationRows = [
  {
    displayName: 'Price/Earnings (P/E)',
    name: 'PriceToEarnings',
    type: '.',
    minmax: [0, 50],
  },
  {
    displayName: 'Price/Earnings (P/E) Excl. Negative',
    name: 'PriceToEarnings_ex_neg',
    type: '.',
  },
  {
    displayName: 'Percent Weight Negative Earn',
    name: 'PctNegEstEarn',
    type: '%',
  },
  {
    displayName: 'Percent Count Negative Earn',
    name: 'PctNegEarn',
    type: '%',
  },

  {
    displayName: 'Estimated Price/Earnings (P/E)',
    name: 'EstPriceToEarnings',
    type: '.',
    minmax: [0, 50],
  },
  {
    displayName: 'Estimated Price/Earnings (P/E) Excl. Negative',
    name: 'EstPriceToEarnings_ex_neg',
    type: '.',
  },
  { displayName: 'Price/Cash Flow (P/CF)', name: 'PriceToCashflow', type: '.' },
  { displayName: 'Price/Book (P/B)', name: 'PriceToBook', type: '.' },
  { displayName: 'Price/Sales (P/S)', name: 'PriceToSales', type: '.' },
];

const sizeRows = [
  { displayName: '# of Stocks', name: 'Constituents', type: '0' },
  {
    displayName: 'Total Market Cap in Billions',
    name: 'MarketCapTotal',
    type: 'b',
  },
  {
    displayName: 'Average Market Cap in Billions',
    name: 'MarketCapAvg',
    type: 'b',
  },
  {
    displayName: 'Median Market Cap in Billions',
    name: 'MarketCapMedian',
    type: 'b',
  },
  {
    displayName: 'Weighted Average Market Cap in Billions',
    name: 'MarketCapWgtAvg',
    type: 'b',
  },
  {
    displayName: '% Weight of ETF with Market Cap > 10 Billion',
    name: 'LargeCapWgt',
    type: '%',
  },
  {
    displayName: '% Weight of ETF with Market Cap 2-10 Billion',
    name: 'MidCapWgt',
    type: '%',
  },
  {
    displayName: '% Weight of ETF with Market Cap < 2 Billion',
    name: 'SmallCapWgt',
    type: '%',
  },
];

const qualityRows = [
  { displayName: 'Return on Assets (ROA%)', name: 'ReturnOnAssets', type: '%' },
  { displayName: 'Return on Equity (ROE%)', name: 'ReturnOnEquity', type: '%' },
  { displayName: 'Return on Sales %', name: 'ReturnOnSales', type: '%' },
  { displayName: 'Leverage', name: 'Leverage', type: '.', minmax: [0, 10] },
  { displayName: 'Gross Margin', name: 'avg_GrossMargin', type: '%100' },
  { displayName: 'Operating Margin', name: 'avg_OCFMargin', type: '%100' },
];

const momentumRows = [
  {
    displayName: 'Price Momentum Score 12 month',
    name: 'wgt_avg_PriceMom12m',
    type: '',
  },
  {
    displayName: 'Price Momentum Score 6 month ',
    name: 'wgt_avg_PriceMom6m',
    type: '',
  },
  {
    displayName: 'Risk Adjusted Momentum Score 12 month',
    name: 'wgt_avg_RAMom12m',
    type: '',
  },
  {
    displayName: 'Risk Adjusted Momentum Score 6 month ',
    name: 'wgt_avg_RAMom6m',
    type: '',
  },
];

const growthCharsRows = [
  {
    displayName: 'Estimated Long Term Growth (3-5 years)',
    name: 'EstLongTermGrowthGRX',
    type: '%100',
  },
  {
    displayName: 'Estimated Short Term Growth (12 months)',
    name: 'EstShrtTermGrowth',
    type: '%100',
  },
  { displayName: 'Implied Growth Rate', name: 'ImpGrowth', type: '%100' },
];

const getAsOfDates = (data) => {
  const maxDates = data.reduce((acc, curr) => {
    const dates = curr.aggregateFundamentals.map((item) => new Date(item.date));
    const maxDate = new Date(Math.max(...dates));
    acc[curr.ticker] = new Date(maxDate.toISOString())
      .toLocaleString()
      .split(',')[0]
      .split(' ')[0];
    return acc;
  }, {});

  const topMaxDate = new Date(
    Math.max(...Object.values(maxDates).map((date) => new Date(date)))
  )
    .toLocaleString()
    .split(',')[0]
    .split(' ')[0];

  let asofDatesReducedDict = Object.keys(maxDates).reduce((acc, curr) => {
    if (maxDates[curr] !== topMaxDate) {
      acc[curr] = maxDates[curr];
    }
    return acc;
  }, {});

  asofDatesReducedDict =
    Object.keys(asofDatesReducedDict).length === 0
      ? null
      : asofDatesReducedDict;

  let memo = '';
  if (asofDatesReducedDict) {
    const tickers = Object.keys(asofDatesReducedDict);
    const dates = Object.values(asofDatesReducedDict).map((date) =>
      date.replace(/\//g, '/')
    );
    const tickerDatePairs = tickers.map(
      (ticker, i) => `${dates[i]} (${ticker})`
    );

    if (tickerDatePairs.length === 1) {
      memo = `Last updated on ${tickerDatePairs[0]}`;
    } else if (tickerDatePairs.length === 2) {
      memo = `Last updated on ${tickerDatePairs.join(' and ')}`;
    } else {
      const lastPair = tickerDatePairs.pop();
      memo = `Last updated on ${tickerDatePairs.join(', ')}, and ${lastPair}`;
    }
  }

  return {
    asofDatesDict: maxDates,
    asOfDate: topMaxDate,
    asofDatesReducedDict: asofDatesReducedDict,
    memo: memo,
  };
};

const CharacteristicsRowNoData = () => {
  return (
    <Fragment>
      <tbody>
        <tr>
          <td colspan="2" style={{ textAlign: 'center' }}>
            {i18n.t('no-data')}
          </td>
        </tr>
      </tbody>
    </Fragment>
  );
};

const CharacteristicsRow = ({ data }) => {
  return data.map((char) => {
    return (
      <CharsRow
        key={char.name}
        displayName={char.displayName}
        charName={char.name}
        charType={char.type}
        minmax={char.minmax}
      />
    );
  });
};

const GrowthCharsRows = ({ type, params }) => {
  const growthMetricQtyHistoricFlag = params.growthMetricQtyHistoricFlag;

  if (growthMetricQtyHistoricFlag === false) {
    return growthCharsRows.map((char) => {
      return (
        <CharsRow
          key={char.name}
          displayName={char.displayName}
          charName={char.name}
          charType={char.type}
          minmax={char.minmax}
        />
      );
    });
  }
  if (growthMetricQtyHistoricFlag === true) {
    return (
      <div>
        <GrowthCharsMetricsTable />
        <div style={{ marginBottom: '0px' }} />
      </div>
    );
  }
};

const CharacteristicsHeader = ({ type, data, asOfDate }) => {
  const renderTicker = (fund) => {
    if (
      fund.type === 'BMK' ||
      fund.type === 'BLEND' ||
      fund.type === 'COD' ||
      fund.type === 'WTMOD'
    ) {
      return (
        <th
          className="textCenter"
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '150px',
          }}
        >
          <span data-tip data-for={`_key_metrics_header`}>
            {fund.ticker.toUpperCase()}
          </span>
        </th>
      );
    } else {
      return (
        <th key={fund.ticker} className="textCenter">
          <a
            className="tickerLinkFC"
            href={fund.fundPageURL || fund.msUrl}
            target="_new"
          >
            {fund.ticker}
          </a>
        </th>
      );
    }
  };

  const renderHeader = () => {
    return (
      <thead>
        <tr>
          <th className="textLeft">
            {i18n.t(`${type}`)} {i18n.t('as of')} {asOfDate}
            <br />
            <span style={{ fontStyle: 'italic' }}>{i18n.t('select-char')}</span>
          </th>
          {data.map((fund) => renderTicker(fund))}
        </tr>
      </thead>
    );
  };

  return renderHeader();
};

const GrowthStatsTableHeader = ({ chartTypeLabel, asOfDate }) => (
  <thead>
    <tr>
      <th colSpan="2" className="textLeft">
        GROWTH CHARACTERISTICS {i18n.t('as of')} {asOfDate}
      </th>
      <th colSpan="3" className="borderleft borderbottom textCenter">
        {i18n.t('Median')} {chartTypeLabel}{' '}
      </th>
      <th colSpan="3" className="borderleft borderbottom textCenter">
        {' '}
        {i18n.t('Weighted Average ')} {chartTypeLabel}{' '}
      </th>
    </tr>
    <tr>
      <th className="textLeft">{i18n.t('Ticker')}</th>
      <th className="textLeft">{i18n.t('Fund')}</th>

      {/* Median  */}
      <th className="textCenter">{i18n.t('1-Year')}</th>
      <th className="textCenter">{i18n.t('3-Year')}</th>
      <th className="textCenter">{i18n.t('5-Year')}</th>
      {/* WeightedAverage  */}
      <th className="textCenter">{i18n.t('1-Year')}</th>
      <th className="textCenter">{i18n.t('3-Year')}</th>
      <th className="textCenter">{i18n.t('5-Year')}</th>
    </tr>
  </thead>
);

const GrowthStatsTableRows = ({ data, wtRegion, chartType }) =>
  data.map((fund) => (
    <GrowthCharsMetricsRow
      key={fund.externalID}
      fund={fund}
      wtRegion={wtRegion}
      chartType={chartType}
    />
  ));

const GrowthMetricsHeader = ({ data, params, EqIncFund, asOfDate }) => {
  const dispatch = useDispatch();
  const growthMetricQualityType =
    params.growthMetricQuality === 'median' ? 'median' : 'weighted';
  const growthMetricQtyHistoricFlag = params.growthMetricQtyHistoricFlag;
  const tickerList = data
    .filter((x) => x?.aggregateFundamentals !== null)
    .map((fund) => {
      if (
        fund.type === 'BMK' ||
        fund.type === 'BLEND' ||
        fund.type === 'COD' ||
        fund.type === 'WTMOD'
      ) {
        return (
          <th
            key={fund.ticker}
            className="textCenter"
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '150px',
            }}
          >
            <span data-tip data-for={`_key_growth_metrics_header`}>
              {fund.ticker.toUpperCase()}
            </span>
          </th>
        );
      } else {
        return (
          <th key={fund.ticker} className="textCenter">
            {fund.fundPageURL && (
              <a className="tickerLinkFC" href={fund.fundPageURL} target="_new">
                {fund.ticker}
              </a>
            )}
            {!fund.fundPageURL && (
              <a className="tickerLinkFC" href={fund.msUrl} target="_new">
                {fund.ticker}
              </a>
            )}
          </th>
        );
      }
    });

  if (growthMetricQtyHistoricFlag === false && EqIncFund) {
    return (
      <tr onClick={(value) => dispatch(setAllGrowthChars(value))}>
        {growthMetricQualityType === 'median' && (
          <th className="textLeft">
            {i18n.t('GrowthMetrics characteristics')} {i18n.t('as of')}{' '}
            {asOfDate}
            <br />
            <span style={{ fontStyle: 'italic' }}>{i18n.t('select-char')}</span>
          </th>
        )}
        {tickerList}
      </tr>
    );
  }
};

const GrowthCharachteristicsSection = ({
  data,
  wtRegion,
  hasMomentumRows,
  momentumRows,
  EqIncFund,
  asOfDate,
}) => {
  const [chartType, setChartType] = useState({
    value: 'SalesGrowth',
    label: 'Sales Growth',
  });

  const handleChartTypeChange = (chartType) => {
    setChartType(chartType);
  };

  return (
    EqIncFund && (
      <Fragment>
        <div className="row" style={{ marginBottom: '20px' }}>
          <div
            className="col-md-3"
            style={{ textAlign: 'center', paddingRight: '3px' }}
          >
            <Select
              options={[
                { value: 'DividendGrowth', label: 'Dividend Growth' },
                { value: 'SalesGrowth', label: 'Sales Growth' },
                { value: 'EBITDAGrowth', label: 'EBITDA Growth' },
                { value: 'EarningsGrowth', label: 'Earnings Growth' },
                { value: 'OCFGrowth', label: 'Operating Cash Flow Growth' },
                { value: 'FCFGrowth', label: 'Free Cash Flow Growth' },
              ]}
              styles={customStyles}
              value={chartType}
              onChange={handleChartTypeChange}
              defaultValue={[{ value: 'SalesGrowth', label: 'Sales Growth' }]}
            />
          </div>
        </div>
        <div>
          <table className="table tableFC">
            <GrowthStatsTableHeader
              chartTypeLabel={chartType.label}
              asOfDate={asOfDate}
            />
            <tbody>
              <GrowthStatsTableRows
                data={data}
                wtRegion={wtRegion}
                chartType={chartType.value}
              />
            </tbody>
          </table>
        </div>
        {hasMomentumRows && (
          <table className="table tableFC">
            <CharacteristicsHeader
              type={'momentum characteristics'}
              data={data}
              asOfDate={asOfDate}
            />
            <CharacteristicsRow data={momentumRows} />
          </table>
        )}
      </Fragment>
    )
  );
};

const EquitySection = ({
  data,
  params,
  EqIncFund,
  hasDividendBuybackRows,
  hasValuationRows,
  hasSizeRows,
  hasQualityRows,
  hasGrowthCharsRows,
  asOfDate,
}) => {
  return (
    EqIncFund && (
      <React.Fragment>
        <table className="table tableFC">
          <CharacteristicsHeader
            type={'dividend characteristics'}
            data={data}
            asOfDate={asOfDate}
          />
          {hasDividendBuybackRows ? (
            <CharacteristicsRow data={dividendBuybackRows} />
          ) : (
            <CharacteristicsRowNoData />
          )}
        </table>

        <table className="table tableFC">
          <CharacteristicsHeader
            type={'valuation characteristics'}
            data={data}
            asOfDate={asOfDate}
          />
          {hasValuationRows ? (
            <CharacteristicsRow data={valuationRows} />
          ) : (
            <CharacteristicsRowNoData />
          )}
        </table>

        <table className="table tableFC">
          <CharacteristicsHeader
            type={'size characteristics'}
            data={data}
            asOfDate={asOfDate}
          />
          {hasSizeRows ? (
            <CharacteristicsRow data={sizeRows} />
          ) : (
            <CharacteristicsRowNoData />
          )}
        </table>

        <table className="table tableFC">
          <CharacteristicsHeader
            type={'quality characteristics'}
            data={data}
            asOfDate={asOfDate}
          />
          {hasQualityRows ? (
            <CharacteristicsRow data={qualityRows} />
          ) : (
            <CharacteristicsRowNoData />
          )}
        </table>

        <table className="table tableFC">
          <thead>
            <GrowthMetricsHeader
              data={data}
              params={params}
              EqIncFund={EqIncFund}
              asOfDate={asOfDate}
            />
          </thead>
          {hasGrowthCharsRows ? (
            <GrowthCharsRows params={params} />
          ) : (
            <CharacteristicsRowNoData />
          )}
        </table>
      </React.Fragment>
    )
  );
};

const FixedIncomeSection = ({
  data,
  hasFxdIncFund,
  fixedIncomeRows,
  hasFxdIncFundHist,
  asOfDate,
}) => {
  if (!hasFxdIncFundHist) {
    return null;
  }
  return (
    <table className="table tableFC">
      <CharacteristicsHeader
        type={'fxdInc characteristics'}
        data={data}
        asOfDate={asOfDate}
      />
      {hasFxdIncFund ? (
        <CharacteristicsRow data={fixedIncomeRows} />
      ) : (
        <CharacteristicsRowNoData />
      )}
    </table>
  );
};

const FundInfoSection = ({ EqIncFund, staleDataMessage }) => {
  return (
    <div className="subjectToChange">
      {EqIncFund && (
        <span>
          *{i18n.t('subject to change')} {i18n.t('fund-info')}
        </span>
      )}

      {staleDataMessage && (
        <div>
          <span>*{staleDataMessage}</span>
        </div>
      )}
    </div>
  );
};

const CharsTable = () => {
  let data = useSelector((state) => state.fundData.data);
  data = data.filter((x) => x.aggregateFundamentals !== null);
  const asOfDates = getAsOfDates(data);

  const params = useSelector((state) => state.params);
  const wtRegion = params.wtRegion;
  const hasAggData = data.length > 0;

  const RenderNoAggData = () => {
    return (
      <div>
        <div className="noData">{i18n.t('no-data')}</div>
        <div style={{ marginBottom: '65px' }} />
        <CompText pane="Chars" />
      </div>
    );
  };

  // if we have the agg data loaded but no data from the wanted fields, show no data
  if (!hasAggData) {
    return <RenderNoAggData />;
  }

  const rowNames = [
    ...dividendBuybackRows,
    ...valuationRows,
    ...sizeRows,
    ...qualityRows,
    ...growthCharsRows,
    ...momentumRows,
  ].map((row) => row.name);

  const filterData = (data, rows, history = -1) => {
    return data.some((x) => {
      const lastAggKeys = x.aggregateFundamentals
        ?.slice(history)
        .map((agg) => agg.keys);
      return rows.some((row) => lastAggKeys.some((keys) => keys.includes(row)));
    });
  };

  const EqIncFund = filterData(data, rowNames);
  const EqIncFundHist = filterData(data, rowNames, -6);
  const hasDividendBuybackRows = filterData(
    data,
    dividendBuybackRows.map((row) => row.name)
  );
  const hasValuationRows = filterData(
    data,
    valuationRows.map((row) => row.name)
  );
  const hasSizeRows = filterData(
    data,
    sizeRows.map((row) => row.name)
  );
  const hasQualityRows = filterData(
    data,
    qualityRows.map((row) => row.name)
  );
  const hasGrowthCharsRows = filterData(
    data,
    growthCharsRows.map((row) => row.name)
  );
  const hasMomentumRows = filterData(
    data,
    momentumRows.map((row) => row.name)
  );
  const hasFxdIncFund = filterData(
    data,
    fixedIncomeRows.map((row) => row.name)
  );
  const hasFxdIncFundHist = filterData(
    data,
    fixedIncomeRows.map((row) => row.name),
    -6
  );
  const hasNoDataFromWantedFields =
    EqIncFundHist.length === 0 && hasFxdIncFundHist.length === 0;

  // if we have the agg data loaded but no data from the wanted fields, show no data
  if (hasNoDataFromWantedFields) {
    return <RenderNoAggData />;
  }

  return (
    <div>
      <div className="chars-table">
        <div className={'table-responsive'}>
          <EquitySection
            data={data}
            wtRegion={wtRegion}
            params={params}
            EqIncFund={EqIncFund}
            hasDividendBuybackRows={hasDividendBuybackRows}
            hasValuationRows={hasValuationRows}
            hasSizeRows={hasSizeRows}
            hasQualityRows={hasQualityRows}
            hasGrowthCharsRows={hasGrowthCharsRows}
            asOfDate={asOfDates.asOfDate}
          />
          <GrowthCharachteristicsSection
            data={data}
            wtRegion={wtRegion}
            hasMomentumRows={hasMomentumRows}
            momentumRows={momentumRows}
            EqIncFund={EqIncFund}
            asOfDate={asOfDates.asOfDate}
          />
          <FixedIncomeSection
            data={data}
            hasFxdIncFund={hasFxdIncFund}
            hasFxdIncFundHist={hasFxdIncFundHist}
            fixedIncomeRows={fixedIncomeRows}
            asOfDate={asOfDates.asOfDate}
          />
        </div>
        <FundInfoSection
          EqIncFund={EqIncFund}
          staleDataMessage={asOfDates.memo}
        />
        <CompText pane="Chars" />
      </div>
    </div>
  );
};

export default CharsTable;
